export const LOGIN = 'login';
export const LOGIN_IN = 'login_in';

export const LOGOUT = 'logout';

export const USER = 'user'


// WEBPACK FOOTER //
// ./src/store/types.js